import { InjectionToken } from '@angular/core';
import { ApiDomain, ApiVersion } from './api-config.token';

export type ApiEndpoint = {
  path: string;
  domain?: ApiDomain;
  version?: ApiVersion;
};

export type AuthApiEndpoints = {
  login: ApiEndpoint;
  setPassword: ApiEndpoint;
};

export type ReportApiEndpoints = {
  list: ApiEndpoint;
  exportSummary: ApiEndpoint;
  exportCustom: ApiEndpoint;
};

export type UserApiEndpoints = {
  list: ApiEndpoint;
  detail: ApiEndpoint;
  create: ApiEndpoint;
  update: ApiEndpoint;
  delete: ApiEndpoint;
};

export type MeterApiEndpoints = {
  list: ApiEndpoint;
  info: ApiEndpoint;
  create: ApiEndpoint;
  update: ApiEndpoint;
  delete: ApiEndpoint;

  testSync: ApiEndpoint;

  brands: ApiEndpoint;
  panels: ApiEndpoint;
  loops: ApiEndpoint;
  tags: ApiEndpoint;
  tenants: ApiEndpoint;
  locations: ApiEndpoint;
  publicUnits: ApiEndpoint;
  groups: ApiEndpoint;
};

export type TenantsApiEndpoints = {
  list: ApiEndpoint;
  create: ApiEndpoint;
  update: ApiEndpoint;
  delete: ApiEndpoint;
  dictionary: ApiEndpoint;
};

export type ExploreApiEndpoints = {
  getEmsExplore: ApiEndpoint;

  getExploreByParam: ApiEndpoint;
  getExploreByMeter: ApiEndpoint;
};

export type BillingApiEndpoints = {
  get: {
    tenants: ApiEndpoint;
    records: ApiEndpoint;
  };
  create: {
    records: ApiEndpoint;
  };
};

export type DiagramApiEndpoints = {
  get: {
    diagram: ApiEndpoint;
  };
};

export type GroupBaselineApiEndpoints = {
  get: {
    group: ApiEndpoint;
    graph: ApiEndpoint;
    log?: ApiEndpoint;
  };
  create: {
    group: ApiEndpoint;
  };
  update: {
    group: ApiEndpoint;
  };
  delete: {
    group: ApiEndpoint;
  };
};

export type TagsApiEndpoints = {
  get: ApiEndpoint;
  create: ApiEndpoint;
  update: ApiEndpoint;
  delete: ApiEndpoint;
};

export type DashboardApiEndpoints = {
  get: {
    dashboard_mdb: ApiEndpoint;
    dashboard_mdb_data: ApiEndpoint;
  };
};

export type ApiEndpoints = {
  auth: AuthApiEndpoints;
  report: ReportApiEndpoints;
  user: UserApiEndpoints;
  meter: MeterApiEndpoints;
  tenants: TenantsApiEndpoints;
  explore: ExploreApiEndpoints;
  group_baseline: GroupBaselineApiEndpoints;
  billing: BillingApiEndpoints;
  tags: TagsApiEndpoints;
  // diagram: DiagramApiEndpoints;
  dashboard: DashboardApiEndpoints;
};

export const API_ENDPOINTS = new InjectionToken<ApiEndpoints>('API_ENDPOINTS');
